jQuery(function ($) {
  gsap.registerPlugin(ScrollTrigger);

  // info graphic
  const jsGraphic = document.querySelectorAll('.js-graphic');
  jsGraphic.forEach(function (jsGraphic) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: jsGraphic,
        start: 'top 70%',
        end: 'bottom 0%',
        once: true,
        scrub: false,
        // markers: true,
        toggleClass: 'is-active',
      },
    });
  });

  const jsCount = document.querySelectorAll('.js-count');
  jsCount.forEach(function (jsCount) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: jsCount,
        start: 'top 70%',
        end: 'bottom 0%',
        once: true,
        scrub: false,
        // markers: true,
        toggleClass: 'is-count__active',
        onEnter: () => {
          countup(jsCount);
          //   countdown(jsCount);
        },
      },
    });
  });

  const jsCountDown = document.querySelectorAll('.js-countdown');
  jsCountDown.forEach(function (jsCountDown) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: jsCountDown,
        start: 'top 70%',
        end: 'bottom 0%',
        once: true,
        scrub: false,
        // markers: true,
        toggleClass: 'is-count__active',
        onEnter: () => {
          countdown(jsCountDown);
        },
      },
    });
  });

  // カウントアップ
  function countup(jsCount) {
    const jsNum = jsCount.querySelector('.js-num');
    if (jsNum.getAttribute('data-num').indexOf('.') > -1) {
      var rounding = 1;
    } else {
      var rounding = 0;
    }
    $(jsNum).numerator({
      easing: 'swing',
      duration: 1200, //カウントアップの時間
      //   fromValue: 20, //カウントスタートの数値
      toValue: jsNum.getAttribute('data-num'), //カウントアップする数値
      //delimiter: ',',　//3桁区切りの記号
      //rounding: rounding, //小数点以下の桁数（初期値：0）
    });
  }
  //カウントダウン
  function countdown(jsCount) {
    const jsNumDown = jsCount.querySelector('.js-num__countdown');
    if (jsNumDown.getAttribute('data-num').indexOf('.') > -1) {
      var rounding = 1;
    } else {
      var rounding = 0;
    }
    $(jsNumDown).numerator({
      easing: 'swing',
      duration: 1200, //カウントダウンの時間
      fromValue: jsNumDown.getAttribute('data-num'), //カウントダウンの開始値
      toValue: 1973, //カウントダウンする数値
      //delimiter: ',',　//3桁区切りの記号
      //rounding: rounding, //小数点以下の桁数（初期値：0）
    });
  }

  $(window).on('load', function () {
    ScrollTrigger.refresh();
  });
});
